import { CopyOutlined, ExportOutlined } from "@ant-design/icons";
import { Button, Input, message } from "antd";
import React, { useState } from "react";
import useAxios from "../../../hooks/useAxios";
import { ReactLoading } from "../../Dashboard/TinManagement/import";

const TinNumber = ({ data }) => {
  const api = useAxios();
  const [loading, setLoading] = useState(false);

  const copyHandle = (tinNo) => {
    navigator.clipboard.writeText(tinNo).then(() => {
      message.success("Copied");
    });
  };

  const takeTestIntimation = async () => {
    try {
      setLoading(true);
      await api.put(
        `/manageTin/tinAttemptStatus/${data?.tinNo}`,
        {},
        {
          tokenType: "candidate",
        },
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const takeTest = async () => {
    await takeTestIntimation();
    window.open(data?.takeTestUrl, "_blank");
  };

  const isTestCompleted =
    data?.status === "COMPLETED" || data?.status === "SCORED";

  return (
    <>
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="w-full">
        <p className="text-[12px] m-0 font-semibold">TIN NUMBER</p>
        <div className="flex gap-1">
          <Input
            className="font-semibold w-full"
            type="text"
            value={data?.tinNo}
            placeholder="e.g. 35654"
            disabled
          />
          <Button
            onClick={(e) => copyHandle(data?.tinNo)}
            disabled={!data?.tinNo}
            className="px-2"
          >
            <CopyOutlined />
          </Button>
        </div>
        {!isTestCompleted ? (
          <div className="mt-2">
            <button
              type="button"
              onClick={takeTest}
              className="btn btn-primary w-full !font-semibold uppercase"
            >
              start versant {data?.tinType || ""} test &nbsp;{" "}
              <ExportOutlined className="!font-semibold text-[13px]" />
            </button>
          </div>
        ) : (
          <div className="mt-2">
            <p className="text-[12px] m-0 text-success">
              Test Completed Successfully.
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default TinNumber;
